import { render, staticRenderFns } from "./GroupInvitationItem.vue?vue&type=template&id=558ba9c8&scoped=true&"
import script from "./GroupInvitationItem.vue?vue&type=script&lang=js&"
export * from "./GroupInvitationItem.vue?vue&type=script&lang=js&"
import style0 from "./GroupInvitationItem.vue?vue&type=style&index=0&id=558ba9c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558ba9c8",
  null
  
)

export default component.exports